export default function useResize(Table) {
    return Table;
}

useResize.displayName = 'useResize';
useResize.dependence = [];
useResize.hooks = function() {
    this.store.rowsHeight = {};
    this.store.columnsWidth = {};

    function getCurrentTableId (store) {
        let { tableId } = store.flatInfo || {};
        let { id } = store.componentConfig;
        tableId = tableId || id;
        return tableId;
    } 
    
    return {
        setColumnsWidth: widths => {
            let tableId = getCurrentTableId(this.store);
            
            //以id维度存储
            this.store.columnsWidth[tableId] = widths;

            this.updateColumnsWidth();
        },
        getColumnsWidth: () => {
            let tableId = getCurrentTableId(this.store);

            return this.store.columnsWidth[tableId];
        },
        updateColumnsWidth: ({ shouldUpdate = true } = {}) => {
            let tableId = getCurrentTableId(this.store);
            let lastOffset = 0;

            this.store.columnWidthOffsets = this.store.visibleLeafColumnKeys.reduce((offsets, colKey) => {
                offsets[colKey] = lastOffset;
                lastOffset += this.store.columnsWidth[tableId]?.[colKey] ?? this.getColumnProps(colKey, 'width');
                return offsets;
            }, {});

            shouldUpdate && this.forceUpdate();
        },
        resetColumnsWidth: () => {
            
            let tableId = getCurrentTableId(this.store);
            this.store.columnsWidth[tableId] = {};

        },
        setRowsHeight: heights => {
            this.store.rowsHeight = heights;
            this.updateRowsHeight();
        },
        getRowsHeight: () => {
            return this.store.rowsHeight;
        },
        updateRowsHeight: ({ shouldUpdate = true } = {}) => {
            let lastOffset = 0,
                rowHeight = this.getComponent('Table')?.current.props.rowHeight ?? this.store.componentConfig?.rowHeight ?? 30;

            this.store.rowHeightOffsets = this.store.visibleRowKeys.reduce((offsets, rowKey) => {
                offsets[rowKey] = lastOffset;
                lastOffset += this.store.rowsHeight?.[rowKey] ?? rowHeight;
                return offsets;
            }, {});

            shouldUpdate && this.forceUpdate();
        },
        resetRowsHeight: () => {
            this.store.rowsHeight = null;
            this.forceUpdate();
        },

    };
};
useResize.propsGenerator = function(props) {
    return {
        ...props,
        columnsWidth: props.store.getColumnsWidth(),
        rowsHeight: props.store.getRowsHeight(),
        onColumnResize: widths => {
            props.store.setColumnsWidth(widths);
        },
        onRowResize: heights => {
            props.store.setRowsHeight(heights);
        },
    };
};